import axios from 'axios';
import { collectionFilter } from '../../mixins/collectionFilter';
import contentBannerCard from '../collection-card/content-banner-card.vue';
import uptProductCard from '../collection-card/upt-product-card.vue';
import loadingAnimation from '../../loading-animation.vue';
import { SortOptions, ColorwaySort } from '../../enums/collections.js';
import CollectionFilters from '../collection-filters/collection-filters.vue';

export default {
  name: 'uptCollectionGrid',
  components: {
    ContentBannerCard: contentBannerCard,
    UptProductCard: uptProductCard,
    LoadingAnimation: loadingAnimation,
    CollectionFilters,
  },
  mixins: [collectionFilter],
  props: [
    'collectionId',
    'group',
    'groupNumber',
    'groupDiscountType',
    'groupTiers',
    'showFilters',
    'sideBySide',
    'colorwaySort',
    'heroBackground',
    'bundleBuilder',
    'allGroupsHaveOneProduct'
  ],
  data() {
    return {
      startPosition: 300,
      endPosition: 1000,
      scrolled: false,
      lastPosition: 0,
      //contBanner: [],
      isGridView: true,
      activeFilterDrawer: null,
      sortSelected: 'Featured',
      isDrawerOpen: false,
      isSortOpen: false,
      selectedOptions: [],
      selectedSortOption: SortOptions.featured,
      sortOptions: [
        { text: SortOptions.featured, value: SortOptions.featured },
        { text: SortOptions.newest, value: SortOptions.newest },
        { text: SortOptions.lowToHigh, value: SortOptions.lowToHigh },
        { text: SortOptions.highToLow, value: SortOptions.highToLow },
        { text: SortOptions.aToZ, value: SortOptions.aToZ },
        { text: SortOptions.zToA, value: SortOptions.zToA },
        //{ text: 'Rating (High to Low)', value: 'Rating' }, removing this option until we figure out what to do with getting collection rating data.
      ],
      filters: [],
      noFilters: false,
      products: this.group.products,
      filteredProducts: [],
      sortedProducts: [],
      priceRange: [],
      showProducts: false,
      showTheRest: false,
      buttonText: 'Load More',
      groupMaxMet: false,
    };
  },
  computed: {
    // cBanner: function () {
    //   return this.contBanner || [];
    // },
    minDiscountValue() {
      if (!this.groupTiers || Object.keys(this.groupTiers).length === 0) return null;

      const validDiscounts = Object.values(this.groupTiers)
        .map(tier => tier.discountValue)
        .filter(val => val !== null && val !== '' && val !== undefined)
        .map(val => Number(val))
        .filter(val => !isNaN(val));

      return validDiscounts.length > 0 ? Math.min(...validDiscounts) : null;
    },
    displayFilters: function () {
      return (this.showFilters || false) && !this.noFilters;
    },
    // minimum price from product list, for price filter
    minPrice: function () {
      let min = Number(this.products[0].minPrice);
      this.products.forEach((product) => {
        if (Number(product.minPrice) < min) min = Number(product.minPrice);
      });
      return Math.floor(min);
    },
    // maximum price from product list, for price filter
    maxPrice: function () {
      let max = Number(this.products[0].maxPrice);
      this.products.forEach((product) => {
        if (Number(product.maxPrice) > max) max = Number(product.maxPrice);
      });
      return Math.ceil(max);
    },
    // returns whether the price filter is active or not
    priceFilterIsActive: function () {
      const minRange = this.priceRange[0];
      const maxRange = this.priceRange[1];
      // check price range against min and max prices
      if (minRange && maxRange) {
        if (minRange > this.minPrice) return true;
        if (maxRange < this.maxPrice) return true;
        else return false;
      } else return false;
    },
    productsFiltered: function () {
      return this.selectedOptions.length > 0 || this.priceFilterIsActive;
    },
  },
  watch: {
    filteredProducts(newFilteredProducts) {
      // this is weird syntax, but I think necessary in order to make sure changes to the
      // sortedProducts array don't affect the newFilteredProducts array and create infinite loop
      // https://stackoverflow.com/a/54802217
      this.sortedProducts = newFilteredProducts.map((p) => ({ ...p }));
      // we want to resort the products whenever the list changes
      this.sortProducts(this.selectedSortOption);
    },
    // sort products when sort option is changed
    selectedSortOption(newSort) {
      // if sort option is featured, we need to grab the original list again
      // since it has the original "featured" sorting
      if (newSort === SortOptions.featured) {
        this.sortedProducts = this.filteredProducts.map((p) => ({ ...p }));
      }
      this.sortProducts(newSort);
    },
    bundleBuilder: {
      handler(newValue, oldValue) {
        //determine if group min is met for 'add another' messaging on product card
        let numFilledInProductGroup = this.countBundleItemsInGroup();
        if (numFilledInProductGroup >= this.group.max) {
          this.groupMaxMet = true;
        } else {
          this.groupMaxMet = false;
        }
      },
      deep: true,
    },
  },
  methods: {
    loadingClicked() {
      this.buttonText = 'Loading...';
      setTimeout(() => {
        this.showTheRest = true;
      }, '50');
    },
    updateFilteredProducts(newFilteredProducts) {
      this.filteredProducts = newFilteredProducts;
      // if the filteredProducts array length is >0 at least once,
      // everything should be loaded and we want to show the grid
      if (this.filteredProducts.length > 0) {
        this.showProducts = true;
      }
    },
    //NEW FILTERING METHODS
    unselectOption(option) {
      this.$refs.filters.unselectOption(option);
    },

    //uncheck all checkboxes
    clearFilters() {
      // use the CollectionFilters component method to clear the filters
      this.$refs.filters.clearFilters();
      this.$refs.filters.resetPriceFilter();
    },

    // reset / turn off price filter
    resetPriceFilter() {
      this.$refs.filters.resetPriceFilter();
    },

    // close the sort
    closeTheSort: function () {
      this.isSortOpen = false;
    },
    // sort the products according to selected option
    sortProducts(sortOption) {
      this.closeTheSort();
      // sort the colorways
      this.sortColorways();

      // if sort option is "featured", we can keep original order, as it should
      // reflect sorting of the collection in Shopify
      // sort the products
      switch (sortOption) {
        // high price to low price
        case SortOptions.highToLow:
          this.sortedProducts.sort((productA, productB) => {
            // the highToLow and lowToHigh sort options only need to look at the first colorway since
            // colorways have already been sorted according to price
            return productB.colorways[0].price - productA.colorways[0].price;
          });
          break;
        // low price to high price
        case SortOptions.lowToHigh:
          this.sortedProducts.sort((productA, productB) => {
            return productA.colorways[0].price - productB.colorways[0].price;
          });
          break;
        // newest products first
        case SortOptions.newest:
          this.sortedProducts.sort((productA, productB) => {
            // if one of these has the new tag and the other does not, the new tag should automatically win (sorted higher).
            if (productA.tags.includes('new') && !productB.tags.includes('new'))
              return -1;
            if (!productA.tags.includes('new') && productB.tags.includes('new'))
              return 1;
            // otherwise (both have 'new' tag or neither do), we just sort on created date
            return new Date(productB.createdAt) - new Date(productA.createdAt);
          });
          break;
        case SortOptions.aToZ:
          this.sortedProducts.sort((productA, productB) => {
            if (productA.title < productB.title) return -1;
            if (productA.title > productB.title) return 1;
            return 0;
          });
          break;
        case SortOptions.zToA:
          this.sortedProducts.sort((productA, productB) => {
            if (productA.title < productB.title) return 1;
            if (productA.title > productB.title) return -1;
            return 0;
          });
          break;
      }
    },

    //sorts the colorways based on group selected in livewire,
    // any active filters and selected sort option on website
    sortColorways() {
      // default to sorting according to what's selected in livewire
      this.sortColorwaysByLivewireOption();

      // if sorting low price to high price, sort colorways that way too
      if (this.selectedSortOption === SortOptions.lowToHigh)
        this.sortColorwaysLowPriceToHighPrice();
      // if sorting high price to low price, sort colorways that way too
      if (this.selectedSortOption === SortOptions.highToLow)
        this.sortColorwaysHighPriceToLowPrice();

      // select the first colorway for each product
      this.selectFirstColorways();
    },
    sortColorwaysHighPriceToLowPrice() {
      this.sortedProducts.forEach((product) => {
        product.colorways.sort((colorwayA, colorwayB) => {
          return colorwayB.price - colorwayA.price;
        });
      });
    },
    sortColorwaysLowPriceToHighPrice() {
      this.sortedProducts.forEach((product) => {
        product.colorways.sort((colorwayA, colorwayB) => {
          return colorwayA.price - colorwayB.price;
        });
      });
    },
    // sort colorways according to the option selected for the PLP in Livewire
    sortColorwaysByLivewireOption() {
      this.sortedProducts.forEach((product) => {
        let currentColorways = product.colorways.filter(
          (color) => color.status === ColorwaySort.current
        );
        let carryoverColorways = product.colorways.filter(
          (color) => color.status === ColorwaySort.carryover
        );
        let saleColorways = product.colorways.filter(
          (color) => color.status === ColorwaySort.sale
        );
        let finalSaleColorways = product.colorways.filter(
          (color) => color.status === ColorwaySort.finalSale
        );
        if (
          this.colorwaySort === ColorwaySort.default ||
          this.colorwaySort === ColorwaySort.current
        ) {
          //sort current, carryover, sale, finalsale
          let sortedColorways = currentColorways.concat(
            carryoverColorways,
            saleColorways,
            finalSaleColorways
          );
          product.colorways = sortedColorways;
        } else if (this.colorwaySort === ColorwaySort.carryover) {
          //sort carryover, current, sale, finalsale
          let sortedColorways = carryoverColorways.concat(
            currentColorways,
            saleColorways,
            finalSaleColorways
          );
          product.colorways = sortedColorways;
        } else if (this.colorwaySort === ColorwaySort.sale) {
          //sort sale, finalsale, carryover, current
          let sortedColorways = saleColorways.concat(
            finalSaleColorways,
            carryoverColorways,
            currentColorways
          );
          product.colorways = sortedColorways;
        } else if (this.colorwaySort === ColorwaySort.finalSale) {
          //sort finalsale, sale, carryover, current
          let sortedColorways = finalSaleColorways.concat(
            saleColorways,
            carryoverColorways,
            currentColorways
          );
          product.colorways = sortedColorways;
        }
      });
    },
    // select the first colorway for each product, after sorting colorways
    selectFirstColorways() {
      this.sortedProducts.forEach((product) => {
        if (product.colorways.length > 0) {
          // if sorting by price lowToHigh and product has a del dia version, select that
          // if it will be the cheapest "variant"
          if (
            this.selectedSortOption === SortOptions.lowToHigh &&
            this.validDelDiaProduct(product) &&
            product.colorways[0].price > product.delDiaVersion.price
          ) {
            this.switchImages(
              'delDia',
              null,
              product,
              true,
              product.delDiaVersion.price,
              product.delDiaVersion.price
            );
          } else {
            // otherwise, select colorways as normal
            this.switchImages(
              product.colorways[0].name,
              product.colorways[0].image,
              product,
              false,
              product.colorways[0].price,
              product.colorways[0].compareAtPrice,
              product.colorways[0].status
            ); //set the first swatch to be the 'active' one.
          }
        } else if (this.validDelDiaProduct(product)) {
          this.switchImages(
            'delDia',
            null,
            product,
            true,
            product.delDiaVersion.price,
            product.delDiaVersion.price
          ); //if we have no color swatches, then we need to set the del dia item as the active swatch.
        }
      });
    },
    // check if product is a valid del día product
    validDelDiaProduct(product) {
      return (
        product.hasOwnProperty('delDiaVersion') &&
        product.delDiaVersion.inventory != 'none' &&
        product.delDiaVersion.url !== null &&
        product.delDiaVersion.url !== '' &&
        typeof product.delDiaVersion.url !== 'undefined'
      );
    },

    // get filter set for this collection
    getFilters() {
      axios
        .get(
          `https://production-access-api.cotopaxi.com/filter/getFiltersByShopifyCollectionId/${collectionId}`
        )
        .then((response) => {
          this.filters = response.data;
          // if there aren't any filters toggled on, hide filters
          if (this.filters.length === 0) this.noFilters = true;
        })
        .catch((err) => {
          console.log(err);
          this.noFilters = true;
        });
    },

    //handle Scroll
    handleScroll() {
      if (this.$refs.collectionGrid) {
        this.startPosition =
          this.$refs.collectionGrid.getBoundingClientRect().top;
        this.endPosition = this.$refs.productGrid.clientHeight;
        if (this.startPosition <= 60 && this.endPosition > window.scrollY) {
          this.scrolled = true;
        } else {
          this.scrolled = false;
        }
        this.lastPosition = window.scrollY;
      } else {
        return;
      }
    },

    addProductToBundle(product) {
      this.$emit('add-to-bundle', product);
    },

    countBundleItemsInGroup() {
      let count = 0;
      this.bundleBuilder.forEach((item) => {
        if (item.group === this.groupNumber && item.status === 'filled') {
          count++;
        }
      });
      return count;
    },
  },
  beforeMount() {},
  mounted() {
    //this.contBanner = this.contentBanners;
    this.getFilters();
    console.log(this.groupDiscountType);
    console.log('Min Discount Value (on mount):', this.minDiscountValue);
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
